<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/KDVPjO/tc-custom/9781614230076.jpg?1726574218589" alt="This image is the cover for the book Baltimore in the Civil War"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">Baltimore in the Civil War
      </h1>
      <p class="bookDescription body article font2">
        <p>On April 19, 1861, the first blood of the Civil War was spilled in the streets of Baltimore. En route to Camden Station, Union forces were confronted by angry Southern sympathizers, and at Pratt Street the crowd rushed the troops, who responded with lethal volleys. Four soldiers and twelve Baltimoreans were left dead. Marylanders unsuccessfully attempted to further cut ties with the North by sabotaging roads, bridges and telegraph lines. In response to the "Battle of Baltimore," Lincoln declared martial law and withheld habeas corpus in much of the state. Author Harry Ezratty skillfully narrates the events of that day and their impact on the rest of the war, when Baltimore became a city occupied.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Harry A. Ezratty
      </h2>
      
      <p class="authorDescription body article">Harry A. Ezratty was born in New York City. He is a graduate of New York University and Brooklyn Law School. A maritime lawyer by profession, Harry is an independent history scholar. He has authored four books. His first, How to Collect and Protect Works of Art, was followed by three books covering historical subjects: 500 Years in the Jewish Caribbean, They Led the Way and The Builders. Harry lectures extensively and teaches American Jewish history at Howard Community College in Maryland. After living and practicing law in Puerto Rico for thirty-five years, he returned to the mainland, settling in Baltimore, where he became interested in the city's rich history, especially the Pratt Street Riot. Harry is married to Barbara Tasch, a journalist, editor and publisher who grew up in Baltimore.</p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      The History Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?da9dba26